import dayjs from 'dayjs';

/**
 * Formats a date string into the "DD-MM-YYYY" format using the dayjs library.
 *
 * @param {string} dateString - The date string to be formatted. If not provided, an empty string is used.
 * @return {string} The formatted date string in the "DD-MM-YYYY" format.
 */
export function dateFormatter(dateString = "") {
  return dayjs(dateString).format("DD-MM-YYYY");
}